import * as React from 'react'

import { Formik } from 'formik'
import { Navigate } from 'react-router-dom'
import LinearProgress from '@mui/material/LinearProgress'

import { ENTITY_TYPES } from '@sales-center/common'

import { useOnSubmit } from '../../hooks'
import { useValidate } from '../../formik'
import { useDuplicateData } from './useDuplicateData'
import { AddOpportunityForm } from '../../AddOpportunityForm/AddOpportunityForm'

export function AddOpportunityFromDuplicateAlert() {
  const {
    ref,
    billTo,
    loading,
    title,
    initialValues,
    serviceLocations,
    externalSvcLocId,
    hasRequiredData,
    noteCodes,
  } = useDuplicateData()

  const onSubmit = useOnSubmit({
    entityType: ENTITY_TYPES.Opportunity,
  })

  const { validate } = useValidate()

  if (!hasRequiredData) return <Navigate to="/opportunities/addOpportunity" />

  return loading ? (
    <LinearProgress />
  ) : (
    <Formik
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues}
    >
      <AddOpportunityForm
        innerRef={ref}
        entityId={-1}
        billTo={billTo}
        title={title}
        serviceLocationsLoading={false}
        serviceLocations={serviceLocations}
        entityType={ENTITY_TYPES.Opportunity}
        externalSvcLocId={externalSvcLocId}
        noteCodes={noteCodes}
      />
    </Formik>
  )
}
